import { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { openBulkCancelModal } from '../../../store/orders/edit-order/edit.order.actions';
import { useAdvancedSearchStatusDisabled } from '../disabled-hooks/use-advanced-search-status-disabled';
import { useOneOrMoreOrderSelectedDisabled } from '../disabled-hooks/use-one-or-more-order-selected-disabled';
import { messages } from './messages';

export const useAdvancedSearchCancelOrder = () => {
  const dispatch = useDispatch();
  const advancedSearchStatusDisabled = useAdvancedSearchStatusDisabled();
  const oneOrMoreOrderSelectedDisabled = useOneOrMoreOrderSelectedDisabled();

  const actionHandler = useCallback(() => {
    dispatch(openBulkCancelModal());
  }, [dispatch]);

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsCancelOrder,
      isDisabled: advancedSearchStatusDisabled || oneOrMoreOrderSelectedDisabled,
      disabledReason: null,
    };
  }, [actionHandler, advancedSearchStatusDisabled, oneOrMoreOrderSelectedDisabled]);
};
